// extracted by mini-css-extract-plugin
export var icon = "_52-1";
export var subtext = "_52-0";